import styled from 'styled-components';
import { Link } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const MenuBtn = styled(FontAwesomeIcon)`
  display: none;
  font-size: 40px;
  width: 40px;
  color: ${({ theme }) => theme.mainColors.hvid};
  @media screen and (max-width: 1090px) {
    display: block;
  }
`;

export const Nav = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  padding-top: 10px;
  height: max-content;
  z-index: 10;
  transition: all 350ms ease-out;
  & button {
    width: 125px;
  }
  &.active {
    box-shadow: 0 20px 30px 0 rgb(0 0 29 / 7%);
    padding-top: 0;
    background-color: ${({ theme }) => theme.mainColors.hvid};
    & ${MenuBtn} {
      color: black;
    }
    & > div {
      
  transition: padding 350ms ease-out;
      padding: 0 25px;
    }
    & div div ul li a {
      
  transition: all 250ms ease-out;
      color: #000;
    }
    & button {
      transition: all 250ms ease-out;
      font-weight: 400;
      color: #fff;
      background-size: 300% 100%;
      border-radius: 5px;
      background-image: linear-gradient(
        to right,
        #25aae1,
        #4481eb,
        #04befe,
        #3f86ed
      );
      box-shadow: 0 15px 30px 0 rgba(65, 132, 234, 0.25);
      &:hover {
        background-position: 100% 0;

    transform: translate3d(0, 3px, 0) scale3d(0.95, 0.95, 1);

    box-shadow: 0 5px 10px 0 rgba(65, 132, 234, 0.75);
  }
  &:focus {
    outline: none;
  }
  &:active {
    transform: translate3d(0, 3px, 0) scale3d(0.9, 0.9, 1);
    box-shadow: 0 2px 5px 0 rgba(65, 132, 234, 0.5);
  }
      }    
    }
  }
`;

export const Navigation = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 10px 25px;
  align-items: center;
  justify-content: space-between;
  position: relative;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  min-height: 75px;
  z-index: 2;
  box-sizing: border-box;
`;

export const LogoCon = styled.div`
  display: flex;
  width: 200px;
  justify-content: flex-start;
  align-items: center;
  font-size: 25px;
  color: ${({ theme }) => theme.mainColors.hvid};
`;

export const LinksCon = styled.div`
  flex-basis: 75%;
  flex-grow: 1;
  justify-content: flex-end;
  @media screen and (max-width: 1090px) {
    flex-basis: 50px;
  }
`;

export const LinkConInner = styled.ul`
  display: flex;
  flex-direction: row;
  list-style: none;
  justify-content: flex-end;
  padding-right: 20px;
  align-items: center;
  column-gap: 40px;
  @media screen and (max-width: 1090px) {
    display: none;
  }
`;

export const NavLinkCon = styled.li`
  display: block;
  width: max-content;
  box-sizing: border-box;
  transition: all 200ms ease-out;
  &:hover {
    transform: scale3d(1.05, 1.05, 1);
  }
`;

export const NavLink = styled(Link)`
  text-decoration: none !important;
  color: ${({ theme }) => theme.mainColors.hvid};
  padding: 0;
  width: max-content;
  font-style: normal;
  font-variant-caps: normal;
  font-variant-ligatures: normal;
  font-variant-numeric: normal;
  font-variant-east-asian: normal;
  font-weight: 500;
  font-stretch: normal;
  font-size: 12px;
  line-height: 15px;
  transition: all 200ms ease-out;
  & a{
    font-style: normal;
    text-decoration: none;
    color: ${({ theme }) => theme.mainColors.hvid};
  }
  &:hover {
    text-shadow: 0 8px 15px 0 rgb(0 0 0 / 25%);
  }
`;

export const CallLink = styled.a`
text-decoration: none !important;
  color: ${({ theme }) => theme.mainColors.hvid};
  padding: 0;
  width: max-content;
  font-style: normal;
  font-variant-caps: normal;
  font-variant-ligatures: normal;
  font-variant-numeric: normal;
  font-variant-east-asian: normal;
  font-weight: 500;
  font-stretch: normal;
  font-size: 12px;
  line-height: 15px;
  transition: all 200ms ease-out;
  & a{
    font-style: normal;
    text-decoration: none;
    color: ${({ theme }) => theme.mainColors.hvid};
  }
  &:hover {
    text-shadow: 0 8px 15px 0 rgb(0 0 0 / 25%);
  }
  `

export const NavPhoneMenu = styled.div`
background-color: ${({ theme }) => theme.mainColors.hvid};
position: fixed;
width: 320px;
top: 0;
right: 0;
height: max-content;
padding: 50px 0;
z-index: 10;
display: block;
border-radius: 10px;
box-shadow: 0 10px 30px rgb(0 0 29 / 25%);
transform: translateY(-120%);
transition: all 350ms ease-out;
&.active{
  transform: translateY(0);
}
& ul {
  list-style-type: none;
  display: flex;
  flex-direction: column;
  row-gap: 25px;
  & li a {
    font-size: 2rem;
    text-decoration: none;
    color: black;
  }
}
`
